import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OEToxnetzTargetType, OEToxnetzTargets, OEToxnetzFeatureAccess, OEToxnetzStartSelectionData} from './oe-toxnetz-model';

export default class OEToxnetzCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OEToxnetzTargetType.organs]:           {icon: OEIconCodes.toxnetz.organsTarget, titleId: 'module_internal_organs'},
            [OEToxnetzTargetType.nervousSystem]:    {icon: OEIconCodes.toxnetz.nervousSystemTarget, titleId: 'module_nervous_system'},
            [OEToxnetzTargetType.skeleton]:         {icon: OEIconCodes.toxnetz.skeletonTarget, titleId: 'module_musculoskeletal_system'},
            [OEToxnetzTargetType.formulae]:         {icon: OEIconCodes.toxnetz.formulaeTarget, titleId: 'module_formulae'},
            [OETarget.effigosExplorerHelp]:         {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = [OEToxnetzTargetType.organs, OEToxnetzTargetType.nervousSystem, OEToxnetzTargetType.skeleton, OEToxnetzTargetType.formulae, OETarget.effigosExplorerHelp];

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OEToxnetzTargets}
                featureAccess={OEToxnetzFeatureAccess}
                startSelectionData={OEToxnetzStartSelectionData}
            />
        );
    }
}